export enum ProductTourStartSourceType {
  Auto = 'auto',
  HelpMenu = 'helpMenu',
}
